// Constantes y enumeraciones compartidas. Sin datos lingüísticos aquí.

export const TILE_TYPE = Object.freeze({
  LETTER: 'letter',
  SYLLABLE: 'syllable',
  PREFIX: 'prefix',
  SUFFIX: 'suffix',
  WILDCARD: 'wildcard',
});

export const PLACEMENT = Object.freeze({
  ANY: 'any',
  START: 'start',
  END: 'end',
});

export const WILD_KIND = Object.freeze({
  UNIVERSAL: 'universal',
  SPLIT: 'split',
  MERGE: 'merge',
  TRANSFORM: 'transform',
});

export const RARITY = Object.freeze({
  COMMON: 'common',
  SPECIAL: 'special',
  RARE: 'rare',
  EPIC: 'epic',
  LEGENDARY: 'legendary',
});

export const GAME_MODE = Object.freeze({
  QUICK: 'quick',
  CLASSIC: 'classic',
  TIMED: 'timed',
  DAILY: 'daily',
  SURVIVAL: 'survival',
  ONLINE: 'online',
  ASYNC: 'async', // 1v1 por turnos vía Firebase (asíncrono, sin estar ambos conectados)
  TUTORIAL: 'tutorial',
});

export const AI_LEVEL = Object.freeze({
  EASY: 'easy',
  NORMAL: 'normal',
  HARD: 'hard',
});

export const SCREEN = Object.freeze({
  LOADING: 'loading',
  HUB: 'hub',
  MODE_SELECT: 'modeSelect',
  DIFFICULTY: 'difficulty',
  GAME: 'game',
  RESULTS: 'results',
  COLLECTION: 'collection',
  PROFILE: 'profile',
  SETTINGS: 'settings',
  CHALLENGES: 'challenges',
  DAILY_WORD: 'dailyWord',
});

// Nombres de eventos del EventBus. Centralizados para evitar cadenas mágicas.
export const EVENTS = Object.freeze({
  // Ciclo de vida
  GAME_START: 'game:start',
  GAME_END: 'game:end',
  STATE_CHANGED: 'state:changed',
  // Turnos
  TURN_START: 'turn:start',
  TURN_CONFIRMED: 'turn:confirmed',
  TURN_INVALID: 'turn:invalid',
  TURN_PASSED: 'turn:passed',
  TILE_DRAWN: 'turn:drawn',
  // Movimientos de fichas
  MOVE_MADE: 'move:made',
  MOVE_UNDONE: 'move:undone',
  BOARD_CHANGED: 'board:changed',
  // Validación
  WORD_VALIDATED: 'word:validated',
  WORD_EVOLVED: 'word:evolved',
  FAMILY_COMPLETED: 'family:completed',
  // Puntuación / progresión
  SCORE_UPDATED: 'score:updated',
  XP_GAINED: 'progress:xp',
  ACHIEVEMENT_UNLOCKED: 'progress:achievement',
  // UI / entrada
  SCREEN_CHANGED: 'ui:screen',
  TILE_PICKED: 'input:tilePicked',
  TILE_DROPPED: 'input:tileDropped',
  // Audio
  PLAY_SFX: 'audio:sfx',
  VIBRATE: 'audio:vibrate',
  // Red (multijugador con amigos)
  NET_ROSTER: 'net:roster',
  NET_PEER_JOINED: 'net:peerJoined',
  NET_PEER_LEFT: 'net:peerLeft',
  NET_STARTED: 'net:started',
  NET_CLOSED: 'net:closed',
  NET_ERROR: 'net:error',
  // Amigos (lista + invitaciones directas)
  FRIEND_INVITE: 'friend:invite',
  FRIEND_REJECT: 'friend:reject',
  FRIENDS_CHANGED: 'friends:changed',
});

export const STORAGE_KEYS = Object.freeze({
  PROFILE: 'wb:profile',
  SETTINGS: 'wb:settings',
  SAVEGAME: 'wb:savegame',
  DAILY: 'wb:daily',
  FRIENDS: 'wb:friends',
});
